
<style>
.custom-dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-btn {
  background: linear-gradient(90deg, #C8102E, #8A1538);
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
}
.dropdown-btn:hover {
  background: linear-gradient(90deg, #8A1538, #C8102E);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

/* Dropdown menu */
.dropdown-content {
  position: absolute;
  top: 110%;
  right: 0;
  background-color: #fff;
  min-width: 200px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  z-index: 99;
  overflow: hidden;
  animation: fadeIn 0.3s ease-in-out;
}

.dropdown-content a {
  display: block;
  color: #333;
  padding: 10px 14px;
  text-decoration: none;
  font-weight: 500;
  transition: background 0.2s, color 0.2s;
}

.dropdown-content a:hover {
  background-color: #f7f7f7;
  color: #C8102E;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* --- Layout container --- */
.right-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-wrap: nowrap;
}


/* Responsive */
@media (max-width: 767px) {
  .title-track {
    flex-direction: column;
    text-align: center;
    gap: 10px;
  }

  .right-actions {
    flex-direction: row;
    justify-content: center; /* ✅ keeps both buttons centered on one line */
    align-items: center;
    flex-wrap: nowrap;
    width: 100%;
  }

  .track-link,
  .dropdown-btn {
    width: auto;
    flex: 1 1 auto;
    text-align: center;
    white-space: nowrap;
  }

  /* ✅ Center dropdown directly under the button */
  .custom-dropdown {
    position: relative;
  }
  .custom-dropdown .dropdown-content {
    left: 50%;
    right: auto;
    transform: translateX(-50%);
    top: 110%;
    width: 220px;
  }
}

.password-wrapper {
  position: relative;
}

.password-toggle {
  position: absolute;
  top: 38px; /* adjust based on input height */
  right: 12px;
  cursor: pointer;
  font-size: 18px;
  user-select: none;
  transition: 0.2s;
}

.password-toggle:hover {
  transform: scale(1.1);
}
p {
    color: #636467 ;
    line-height: 1.7em ;
}
h4 {
    display: block;
    margin-block-start: 1.33em;
    margin-block-end: 1.33em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    unicode-bidi: isolate;
}

</style>
<template>

    <TopBar />
    <Toast ref="toast" />

        <!-- Main content -->
        <main class="main-content-container"  >
          <div class="container">
           
            <h2 class="head-h2">Privacy Policy</h2>

            <div>
                <p><strong><h5>Electronic Payments:</h5></strong></p>
                
                <p>Your privacy is important to us. It is KIMSHEALTH Management Ltd.’s policy to respect your privacy regarding any information we may collect from you across our website https://www.kimshealth.org/trivandrum/ and other sites we own and operate.</p>
                <p>We only ask for personal information when we truly need it to provide a service to you. We collect it by fair and lawful means, with your knowledge and consent. We also let you know why we’re collecting it and how it will be used.</p>
                <p>We only retain collected information for as long as necessary to provide you with your requested service. What data we store, we’ll protect within commercially acceptable means to prevent loss and theft, as well as unauthorised access, disclosure, copying, use or modification.</p>
                <p>We don’t share any personally identifying information publicly or with non-affiliate third-parties, except when required to by law.</p>
                <p>Our website may link to external sites that are not operated by us. Please be aware that we have no control over the content and practices of these sites, and cannot accept responsibility or liability for their respective privacy policies.</p>
                <p>You are free to refuse our request for your personal information, with the understanding that we may be unable to provide you with some of your desired services.</p>

                <p><strong><h5>Collection and processing of personal information:</h5></strong></p>

                <p>Personal information including sensitive personal data may be received, processed or stored by KIMSHEALTH Management Ltd. only under valid contracts entered into with providers.</p>
                <p>The types of personal information received by KIMSHEALTH Management Ltd. may include the following but not limited to: names, addresses of natural persons, as well as sensitive personal data such as password, financial information like Bank account or credit card or debit card or other payment instrument details, medical records and biometric information etc.</p>
                <p>Accessing or correcting your personal information: At any time, the provider can request regarding their own personal information maintained at KIMSHEALTH Management Ltd. for various purposes as listed below but not limited to:</p>

                <ul>
                    <li>General information</li>
                    <li>Update of personal information</li>
                    <li>Deletion of personal information</li>
                </ul>

                <p>KIMSHEALTH Management Ltd. will respond to such requests as soon as possible after confirming the authenticity of the requestor and the request.</p>

                
                <p><strong><h5>INFORMATION COLLECTION AND USE</h5></strong></p>
                <p>Personal Information.</p>
                <p>We Collect Online “Personal Information” i.e. personally identifiable information such as information you provide, or that others provide to us on your behalf, via forms, surveys, applications or other online fields including but not limited to name, postal or email addresses, telephone, fax or mobile numbers.</p>
                
                <p><strong><h5>How We Use Personal Information</h5></strong></p>

                <p>We may use Personal Information to:</p>
                <ul>
                    <li>Respond to your inquiries and fulfil your requests;</li>
                    <li>Send you important information regarding the Site, changes to our terms, conditions, and policies and/or other administrative information;</li>
                    <li>Send you marketing communications that we believe may be of interest to you;</li>
                    <li>Personalize your experience on the Site;</li>
                </ul>
                <p>Allow you to participate in surveys, contests and similar promotions and to administer these activities. Some of these activities have additional rules, which could contain additional information about how we use and disclose Personal Information;</p>
                <p>Analyse data for our business purposes, such as audits, medical records, enhancing the Site, improving our services, identifying usage trends and determining the effectiveness of our promotional campaigns; or Control risk, to comply with laws and regulations and to comply with other legal process and law enforcement requirements.</p>
                <p>Other Information We Collect Online</p>
                <p>“Other Information” is any information other than Personal Information that does not reveal your specific identity or does not directly relate to an individual, such as:</p>
                <ul>
                    <li>Browser information Online Privacy Policy</li>
                    <li>Information collected through cookies, pixel tags and other technologies</li>
                    <li>Demographic information and other information provided buy you such as your date of birth; or</li>
                    <li>Aggregated and De-identified Data</li>
                </ul>

                <p><strong><h5>How we protect your personal information</h5></strong></p>
                <p>To protect your personal information from unauthorized access and use, we use security measures that comply with Indian law. These measures include computer safeguards, Data and Database Encrypting, and secured files and buildings.</p>

                <p><strong><h5>How We Collect and Use Other Information</h5></strong></p>

                <p>We and our affiliate third-party service providers, if any, may record, collect and use Other Information in a variety of ways, including:</p>
                <p>Through your browser: Certain information is collected by most browsers, such as your Media Access Control (MAC) address, device type, screen resolution, operating system version and Internet browser type and version. We use this information to ensure that the Site functions properly and for security purposes.</p>
                <p>Use of cookies: Cookies are pieces of information stored directly on the device you are using. Cookies we use do not contain or capture unencrypted Personal Information. Cookies allow us to collect information such as browser type, time spent on the Site, pages visited and language preferences. We use the information for security purposes, to facilitate navigation, to display information more effectively and to personalize your experience while visiting the Site. We also gather statistical information about the usage of the Site in order to continually improve the design and functionality, to understand how people use the Site and to assist us with resolving questions regarding the Site.</p>
                <p>You can refuse to accept these cookies and most devices and browsers offer their own privacy settings for cookies. You will need to manage your cookie settings for each device and browser you use. However, if you do not accept these cookies, you may experience some inconvenience in your use of the Site.</p>
                <p>Use of an analytics and optimization service that tracks and analyzes activity on the Site. We use the information for security purposes, to facilitate navigation, to display information more effectively, to continually improve the design and functionality and to understand how people use the Site.</p>
                <p>Use of pixel tags, web beacons, clear GIFs or other technologies: These may be used in connection with some Site pages and HTML-formatted email messages to measure the effectiveness of our communications, the success of our marketing campaigns, compile statistics about usage and response rates and to assist us in resolving customers’ questions regarding use of the Site.</p>
                <p>IP Address: Your IP Address is a number that is automatically assigned to the device that you are using by your Internet Service Provider. An IP Address is identified and logged automatically in our server log files whenever a user visits the Site, along with the time of the visit and the page(s) that were visited. Collecting IP Addresses is standard practice on the Internet and is done automatically by many websites. We use IP Addresses for purposes such as calculating Site usage levels, helping diagnose server problems and administering the Site.</p>
                <p>Aggregated and De-identified Data: “Aggregated and De-identified Data” is data we may create or compile from various sources, including mouse clicks and movements, scrolling activity and text you type into the Site. This information is used for business purposes, which may include offering products or services, research, marketing or analyzing market trends and other purposes consistent with applicable laws.</p>
                
                <h3>ADDITIONAL INFORMATION</h3>

                <p><strong><h5>Social Media Sites</h5></strong></p>
                <p>KIMSHEALTH Management Ltd. Hospital and its subsidiaries provide experiences on social media platforms such as Facebook®, Twitter® and LinkedIn® that enable online sharing and collaboration among users who have registered to use them. Any content you post, such as pictures, information, opinions or any Personal Information that you make available to other participants on these social platforms, is subject to the Terms of Use and Privacy Policies of those platforms. Please refer to them to better understand your rights and obligations with regard to such content.</p>

                <p><strong><h5>Links</h5></strong></p>
                <p>If required by law, we may provide any and all information we have about you to law enforcement or other government agencies, pursuant to a subpoena, warrant or other order by a court of competent jurisdiction. Where required by applicable law, we will require written documentation of the request, proof of the identity of the law enforcement official making the request, and we will take steps to authenticate the validity of the request. Any law enforcement or government agency request submitted with less than a court-issued order will be evaluated on a case-by-case basis according to the need and urgency, as well as the particular law enforcement agency making the request.</p>

                <p><strong><h5>Security</h5></strong></p>
                <p>To maintain the accuracy of the Personal Data, as well as to prevent unauthorized access and ensure the correct use of Personal Data, we have implemented appropriate physical, technical, and administrative measures to safeguard and secure the Personal Data we collect.</p>
                <p>We use Secure Socket Layer (SSL) protocol—an industry standard for encryption over the Internet—to protect in transmission the Personal Data we collect online. When you type in sensitive information, it will be automatically converted into codes before being securely dispatched over the Internet. All electronic Personal Data that we maintain in DB is securely stored and further protected through our use of appropriate access controls.</p>
                <p>In addition, to better protect certain Personal Data, some areas of the website channels are inaccessible unless you supply individually identifiable and verifiable information,</p>
                <p>As stated above, in some instances we may entrust Personal Data to third party service providers (including service providers outside of your jurisdiction) upon your acceptance, binding them to protect the security of Personal Data and only to use it for the purposes we specify.</p>


                <p><strong><h5>Privacy Policy Update</h5></strong></p>
                <p>In the future, we may need to change this Online Privacy Notice. Please review it periodically. All changes will be made here so that you will always know what information we gather, how we might use that information and whether we may share it with anyone. Any change to a Privacy Notice will become effective when we post the revised Notice on the Site. Your use of the Site following these revisions acknowledges your receipt of the revision and your agreement to and acceptance of the revised Privacy Notice.</p>


                
            </div>

            </div>
        </main>

    <Footer />



    <!-- Modal -->
    <div class="modal fade" id="agentRegistrationModal" tabindex="-1" aria-labelledby="agentRegistrationModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-right">
            <div class="modal-content p-0" style="overflow: hidden;">

            <!-- Modal Header -->
            <div class="modal-header text-white" style="background-color: #c62828; display: flex; justify-content: space-between; align-items: center;">

                <!-- Left: Title -->
                <h5 class="modal-title" id="agentRegistrationModalLabel">Agent Registration</h5>

                <!-- Right: Logo + Close Button -->
                <div class="d-flex align-items-center">
                    <!-- Logo -->
                    <img src="@/assets/Images/Logo/Footer Logo.png" alt="Logo" style="height: 40px; margin-right: 10px;">
                    
                    <!-- Close Button -->
                    <button type="button" class="btn-close btn-close-white" @click="closeRegAndOpenSignIn" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

            </div>


            <!-- Modal Body -->
            <div class="modal-body">
                <form @submit.prevent="handleRegister">
                      <div class="row">
                          <!-- Company Name -->
                          <div class="col-md-6 mb-3">
                              <label for="companyName" class="form-label">Business/Agency Name</label><span class="text-danger">*</span>
                              <input 
                                  type="text" 
                                  id="companyName" 
                                  class="form-control" 
                                  v-model.trim="form.companyName" 
                                  :class="{'is-invalid': errors.companyName}"
                                  placeholder="Business/Agency">
                              <div class="invalid-feedback">{{ errors.companyName }}</div>
                          </div>

                          <!-- Full Name -->
                          <div class="col-md-6 mb-3">
                              <label for="agentName" class="form-label">Full Name</label><span class="text-danger">*</span>
                              <input 
                                  type="text" 
                                  id="agentName" 
                                  class="form-control" 
                                  v-model.trim="form.fullName" 
                                  :class="{'is-invalid': errors.fullName}"
                                  placeholder="Enter your full name">
                              <div class="invalid-feedback">{{ errors.fullName }}</div>
                          </div>

                          <!-- Email -->
                          <div class="col-md-6 mb-3">
                              <label for="agentEmail" class="form-label">Email Address</label><span class="text-danger">*</span>
                              <input 
                                  type="email" 
                                  id="agentEmail" 
                                  class="form-control" 
                                  v-model.trim="form.email" 
                                  :class="{'is-invalid': errors.email}"
                                  placeholder="example@gmail.com">
                              <div class="invalid-feedback">{{ errors.email }}</div>
                          </div>

                          <!-- Phone -->
                          <div class="col-md-6 mb-3">
                              <label for="agentPhone" class="form-label">Phone Number</label><span class="text-danger">*</span>
                              <input 
                                  type="tel" 
                                  id="agentPhone" 
                                  class="form-control" 
                                  :class="{'is-invalid': errors.phone}"
                                  ref="phoneInput" 
                                  placeholder="(000) 000-0000">
                              <div class="invalid-feedback d-block">{{ errors.phone }}</div>
                          </div>

                          <!-- Aadhar -->
                          <div class="col-md-6 mb-3">
                              <label for="aadharNumber" class="form-label">Aadhar Number</label><span class="text-danger">*</span>
                              <input 
                                  type="text" 
                                  id="aadharNumber" 
                                  class="form-control" 
                                  v-model.trim="form.aadharNumber" 
                                  :class="{'is-invalid': errors.aadharNumber}"
                                  placeholder="Aadhar Number">
                              <div class="invalid-feedback">{{ errors.aadharNumber }}</div>
                          </div>

                          <!-- Full Name -->
                          <div class="col-md-6 mb-3">
                              <label for="gstNumber" class="form-label">GST Number</label>
                              <input 
                                  type="text" 
                                  id="gstNumber" 
                                  class="form-control" 
                                  v-model.trim="form.gstNumber" 
                                  :class="{'is-invalid': errors.gstNumber}"
                                  placeholder="GST Number">
                              <div class="invalid-feedback">{{ errors.gstNumber }}</div>
                          </div>

                          <!-- Address -->
                          <div class="col-md-12">
                              <label for="address" class="form-label">Address</label>
                              <textarea
                                  id="address"
                                  class="form-control"
                                  v-model.trim="form.address"
                                  :class="{'is-invalid': errors.address}"
                                  placeholder="Enter Your Address..."
                                  rows="3"
                              ></textarea>
                              <div class="invalid-feedback">{{ errors.address }}</div>
                          </div>

                      </div>

                      <br>
                      <!-- Confirmation Checkbox -->
                      <div class="col-12 mb-3">
                          <div 
                            class="form-check p-3 border rounded-4 d-flex align-items-start gap-2" 
                            :class="{'border-danger': errors.confirmation}" 
                            style="background-color: #fff5f5; box-shadow: 0 2px 6px rgba(0,0,0,0.05);">
                            
                            <!-- Checkbox -->
                            <input class="form-check-input mt-1" type="checkbox" 
                              id="confirmationCheck" v-model="form.confirmation"
                              :class="{'is-invalid': errors.confirmation}" 
                              style="width: 20px; height: 20px;">
                            
                            <!-- Label -->
                            <label class="form-check-label fw-normal" for="confirmationCheck" 
                              style="font-size: 0.875rem; line-height: 1.5;">
                              I hereby confirm that I shall not be entitled to any commission for visa appointment bookings from KIMS. I and KIMS are completely different parties and do not hold any link.
                            </label>

                          </div>
                          <!-- Error Message -->
                          <div class="invalid-feedback d-block" v-if="errors.confirmation">
                            {{ errors.confirmation }}
                          </div>
                      </div>

                </form>
            </div>

            <!-- Modal Footer -->
            <div class="modal-footer" style="background-color: #c62828;">
                <button type="button" class="btn btn-light" style="cursor: pointer; z-index: 1056;" @click="closeRegAndOpenSignIn" data-bs-dismiss="modal">Close</button>
                <button type="button" :disabled="isSignUpLoading" class="btn btn-light" @click="handleRegister">
                  <span 
                    v-if="isSignUpLoading" 
                    class="spinner-border spinner-border-sm" 
                    role="status" 
                    aria-hidden="true">
                  </span>
                  <span>{{ isSignUpLoading ? 'Wait...' : 'Register' }}</span>
                </button>
            </div>

            </div>
        </div>
    </div>

    <!-- Sign In Modal -->
    <div class="modal fade" id="agentSignInModal" tabindex="-1" aria-labelledby="signInModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content shadow-lg border-0 rounded-4 overflow-hidden">

          <!-- Header (Compact) -->
          <div class="modal-header py-3 px-3 text-white"
              style="background: linear-gradient(135deg, #c62828, #b71c1c); display: flex; justify-content: space-between; align-items: center;">
            <h5 class="modal-title fw-bold mb-0" id="signInModalLabel">Sign In</h5>
            <div class="d-flex align-items-center">
              <img src="@/assets/Images/Logo/Footer Logo.png" alt="Logo" style="height: 30px; margin-right: 10px;">
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close" style="scale: 1.3;"></button>
            </div>
          </div>


          <!-- Body (Compact) -->
          <div class="modal-body py-3 px-3">
            <form @submit.prevent="handleSignIn">
              <!-- Email -->
              <div class="mb-3">
                <label for="signin-email" class="form-label fw-semibold">Email Address</label>
                <input 
                  type="email" 
                  id="signin-email" 
                  :class="['form-control rounded-2', errors.email ? 'is-invalid' : '']" 
                  v-model.trim="signInForm.email" 
                  placeholder="you@example.com" 
                  >
                  <div v-if="errors.email" class="invalid-feedback">{{ errors.email }}</div>
              </div>

              <!-- Password -->
              <div class="mb-3 password-wrapper">
                <label for="signin-password" class="form-label fw-semibold">Password</label>
                <input 
                  :type="showPassword ? 'text' : 'password'"
                  id="signin-password" 
                  :class="['form-control rounded-2 pe-5', errors.password ? 'is-invalid' : '']" 
                  v-model.trim="signInForm.password" 
                  placeholder="••••••••" 
                  >
                <!-- Custom SVG Icon -->
                <!-- Eye toggle using text icon -->
                <span class="password-toggle" @click="togglePassword">
                  <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                </span>
                  <div v-if="errors.password" class="invalid-feedback">{{ errors.password }}</div>
              </div>

              <!-- Forgot password -->
              <div class="d-flex justify-content-between align-items-center mb-3">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="" id="rememberMe">
                  <label class="form-check-label" for="rememberMe">
                    Remember me
                  </label>
                </div>
                <a href="#" class="text-decoration-none text-danger small"></a>
              </div>

              <!-- Button with Loading -->
              <div class="d-grid">
                  <button 
                    type="submit" 
                    class="btn rounded-2 d-flex justify-content-center align-items-center gap-2"
                    :disabled="isLoading"
                    style="
                      background: linear-gradient(135deg, #c62828, #b71c1c);
                      border: none;          /* remove border */
                      box-shadow: none;      /* remove focus/active shadow */
                      color: white;
                    "
                  >
                    <span 
                      v-if="isLoading" 
                      class="spinner-border spinner-border-sm" 
                      role="status" 
                      aria-hidden="true">
                    </span>
                    <span>{{ isLoading ? 'Signing In...' : 'Sign In' }}</span>
                  </button>
              </div>
            </form>
          </div>



          <!-- Footer -->
          <div class="modal-footer justify-content-center bg-light">
            <p class="mb-0 small">Don’t have an account? 
              <a href="javascript:void(0)" @click="openRegistrationFromSignIn" class="text-danger fw-semibold">Create one</a>

            </p>
          </div>

        </div>
      </div>
    </div>

    <!-- otp verification -->
    <div class="modal fade" id="otpAgentRegisterModal" tabindex="-1" aria-labelledby="otpModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content p-4 rounded-4">

                <!-- Close button -->
                <button type="button" class="btn-close position-absolute top-0 end-0 m-3" style="cursor: pointer; z-index: 1056;" @click="closeOtpModal" aria-label="Close"></button>


                <div class="modal-body">
                    <img src="@/assets/Images/Logo/kims-logo.png" alt="KIMSHEALTH" class="mb-3" style="max-width:260px;">
                    <p class="otp_text mb-4">Please enter the OTP received on your email address</p>
        
                    <div class="d-flex justify-content-center mb-3 gap-1 otp-input-group flex-wrap justify-content-between">
                    <input
                        v-for="(digit, index) in otp"
                        :key="index"
                        type="text"
                        class="form-control otp-box text-center"
                        maxlength="1"
                        v-model="otp[index]"
                        @input="focusNext(index, $event)"
                        @keydown.backspace="focusPrev(index, $event)"
                        ref="otpInputs"
                    />
                    </div>
        
                    <small v-if="errors.otpError" class="text-danger">{{ errors.otpError }}</small>
        
                    <a class="btn btn-danger w-100" @click="validationMain(registeredEmail)" :disabled="loading || otpIncomplete">
                      <span v-if="!loading && !resendloading">Confirm</span>
                      <span v-else-if="resendloading">
                        <i class="fa fa-spinner fa-spin"></i> Resending...
                      </span>
                      <span v-else>
                        <i class="fa fa-spinner fa-spin"></i> Processing...
                      </span>
                    </a>
        
                    <div class="d-flex justify-content-between mt-3">
                        <span class="resend">Resend OTP in <span class="timer" :key="formattedTime">{{ formattedTime }}</span></span>
                        <a href="#" 
                          class="resend_btn text-decoration-none" 
                          @click.prevent="handleResend(registeredEmail)" 
                          :class="{'text-muted': timer > 0 || resendloading, 'text-danger': timer === 0 && !resendloading}" 
                          :style="(timer > 0 || resendloading) ? 'pointer-events: none;' : 'pointer-events: auto;'">
                          <span v-if="!resendloading">Resend</span>
                          <span v-else>
                              <i class="fa fa-spinner fa-spin"></i> Resending...
                          </span>
                        </a>

                    </div>
                </div>

          </div>
        </div>
    </div>

    


</template>
<script>
import { ref } from 'vue';
import TopBar from '@/components/Home/Header/TopBar.vue';
import Footer from '@/components/Home/Footer/DownBar.vue';
import Swal from 'sweetalert2';
import { AgentSignUp, AgentVerifyOTP, AgentOTPResend, AgentSignIn, AgentLogout } from '@/api/Agent/sign';
import { useAgentStore } from '@/store/agent';
import Toast from '@/components/Toast/agentToast.vue';
import { useRouter } from 'vue-router';
export default {
    name: 'PrivacyPolicy',
    components: {
        TopBar,
        Footer,
        Toast,
    }, 
    data() {
        return {
            LangingHomePage : '/',
            trackAppointment : '/trackAppointment',
            form: {
                  companyName: '',
                  fullName: '',
                  email: '',
                  phone: '',
                  aadharNumber: '',
                  gstNumber: '',
                  address: '',
                  confirmation: false,
              },
              errors: {},
              signInForm: {
                email: '',
                password: ''
              },
              isLoading: false,
              isSignUpLoading: false,
              otp: Array(5).fill(''),
              errors: { otpError: '' },
              loading: false,
              resendloading: false,
              timer: 180,           // 3 minutes in seconds
              formattedTime: '',
              registeredEmail: '',
              otpTimerInterval: null,
              showDropdown: false,
              showPassword: false,
              isAgentLoggedIn: false,
              agentName: '',
              toast: null,
        };
    },
    computed: {
        otpIncomplete() {
          // Assuming `this.otp` is an array of OTP digits
          return this.otp.some(digit => digit === '' || digit == null);
        }
      },
      mounted() {
          const input = this.$refs.phoneInput;
          this.iti = window.intlTelInput(input, {
          initialCountry: 'in', 
          onlyCountries: ['in'], // only india other wise comment it
          separateDialCode: true,
          utilsScript:
              'https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js',
          });

          input.addEventListener('change', this.updatePhone);
          input.addEventListener('blur', this.updatePhone);

          const otpModalEl = document.getElementById('otpAgentRegisterModal');
          otpModalEl.addEventListener('shown.bs.modal', () => {
            //console.log("OTP Modal opened — timer restarting");
            this.resetOtpTimer();
          });
          document.addEventListener('click', this.handleClickOutside);

          this.checkAgentLogin()
      },
      beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
      },
      methods: {
          updatePhone() {
              // Get national number (may include leading 0)
              let nationalNumber = this.iti.getNumber(intlTelInputUtils.numberFormat.NATIONAL);
              // Remove all non-digit characters
              nationalNumber = nationalNumber.replace(/\D/g, '');
              // Remove leading 0 if present
              if (nationalNumber.startsWith('0')) {
                  nationalNumber = nationalNumber.slice(1);
              }
              this.form.phone = nationalNumber;
              //console.log('this.form.phone : ', this.form.phone);
          },


          handleRegister() {
              this.errors = {}; // reset

              if (!this.form.companyName) this.errors.companyName = 'Company Name is required';
              if (!this.form.fullName) this.errors.fullName = 'Full Name is required';
              if (!this.form.email) this.errors.email = 'Email is required';
              else if (!this.validateEmail(this.form.email)) this.errors.email = 'Enter a valid email';
              if (!this.form.phone) this.errors.phone = 'Phone Number is required';
              else if (this.form.phone.length !== 10) this.errors.phone = 'Enter a valid 10-digit number';
              // --- Conditional Aadhar Validation ---
              if (!this.form.aadharNumber) this.errors.aadharNumber = 'Aadhar Number is required';
              else if (!this.validateAadhar(this.form.aadharNumber)) this.errors.aadharNumber = 'Enter a valid 12-digit Aadhar number';
              // --- Conditional GST Validation ---
              if (this.form.gstNumber) {
                  if (!this.validateGST(this.form.gstNumber)) {
                  this.errors.gstNumber = 'Enter a valid GST number';
                  }
              }

              if (this.form.address) {
                  if (!this.form.address.length > 255) {
                      this.errors.address = 'The address exceeded maximum.';
                  }
              }

              if (!this.form.confirmation) {
                this.errors.confirmation = 'You must confirm before submitting';
              }


              if (Object.keys(this.errors).length === 0) {
                  ///console.log('Form Submitted:', this.form);
                  Swal.fire({
                      title: 'Confirm Registration',
                      text: 'Please check the details you entered carefully. Make sure everything is correct before submitting.',
                      showCancelButton: true,
                      confirmButtonColor: '#d33',
                      cancelButtonColor: '#3085d6',
                      confirmButtonText: 'Yes, submit it!',
                      cancelButtonText: 'Cancel'
                  }).then(async (result) => {
                    if (result.isConfirmed) {
                      try {
                        this.isSignUpLoading = true;
                          
                        //const payload = {
                        const name = this.form.fullName;
                        const email = this.form.email;
                        const phone = (this.form.phone || "").replace(/\D/g, "");
                        const agency_name = this.form.companyName;
                        const aadhaar = (this.form.aadharNumber || "").replace(/\D/g, "");
                        const gst_number = this.form.gstNumber || "";
                        const address = this.form.address || "";
                        ///};
                        //console.log('Final payload going to API:', JSON.stringify(payload, null, 2));
                        //  Call your API or sign-up function here
                        const response = await AgentSignUp(name,email,phone,agency_name,aadhaar,gst_number,address);
                        ///console.log('Form response:', JSON.stringify(response, null, 2));

                        // Check response status
                        if (response.status === 200) {
                          //console.log("Response data:", JSON.stringify(response.data, null, 2));
                              
                          if (response.data.success === true) {
                            Swal.fire({
                              title: 'Registration Successful!',
                              //text: "Your account verification is in process. You won’t be able to access your account until verified. You will receive an email once your account status is updated.",
                              text: response.data.message || 'An OTP has send to email for verification',
                              confirmButtonText: 'Continue',
                              confirmButtonColor: '#d33', // Red button
                              allowOutsideClick: false,   
                              allowEscapeKey: false,     
                              allowEnterKey: true         
                            }).then((result) => {
                              if (result.isConfirmed) {
                                //window.location.reload();
                                // Close registration modal if still open
                                const regModalEl = document.getElementById('agentRegistrationModal');
                                const regModal = bootstrap.Modal.getInstance(regModalEl);
                                if (regModal) regModal.hide();

                                // Open OTP modal
                                const otpModalEl = document.getElementById('otpAgentRegisterModal');
                                const otpModal = new bootstrap.Modal(otpModalEl, { keyboard: false, backdrop: 'static' });
                                otpModal.show();

                                // Optional: reset OTP inputs
                                this.otp = Array(5).fill(''); // assuming 6-digit OTP
                                this.errors.otpError = '';
                                this.registeredEmail = response.data.email;
                              }
                            });

                          } else {
                            Swal.fire({
                              title: 'Error',
                              text: response.data.messages
                                ? Object.values(response.data.messages).flat()[0]  // takes first error message
                                  : 'Registration failed. Please try again.',
                                confirmButtonText: 'OK',
                                confirmButtonColor: '#d33', // red button
                            });
                          }
                        } else {
                          Swal.fire({
                            title: 'Error',
                            text: response.data?.message || `Server responded with status ${response.status}`,
                          });
                        }

                      } catch (error) {
                        console.error('Sign up error:', error);
                        // Generic error message
                        Swal.fire({
                          title: 'Something went wrong',
                          text: 'Please check your internet connection or try again later.',
                        });
                      } finally {
                        this.isSignUpLoading = false;
                      }
                    }
                  });
              }
          },

          validateEmail(email) {
              const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              return re.test(email);
          },

          validateAadhar(aadhar) {
            // Remove all non-digit characters
            const digits = aadhar.replace(/\D/g, '');
            // Aadhar must be exactly 12 digits
            return /^[0-9]{12}$/.test(digits);
          },

          // GST Validation Function
          validateGST(gst) {
              // GST format: 2 digits state code + 10 PAN + 1 entity code + 1 Z + 1 checksum
              const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
              return gstRegex.test(gst);
          },

          // Agent sign in
          async handleSignIn() {
              this.errors = {}; // reset errors

              // Validation
              let valid = true;
              if (!this.signInForm.email) {
                this.errors.email = 'Email is required';
                valid = false;
              } else if (!/^\S+@\S+\.\S+$/.test(this.signInForm.email)) {
                this.errors.email = 'Enter a valid email';
                valid = false;
              }

              if (!this.signInForm.password) {
                this.errors.password = 'Password is required';
                valid = false;
              } else if (this.signInForm.password.length < 6) {
                this.errors.password = 'Password must be at least 6 characters';
                valid = false;
              }

              if (!valid) return;

              // Start loading
              this.isLoading = true;

              try {
                // Simulate API call
                //console.log('Signed in with:', this.signInForm);
                const response = await AgentSignIn(this.signInForm);
                ///console.log('Form response:', JSON.stringify(response, null, 2));

                // Check response status
                if (response.status === 200) {
                  ///console.log("Response data:", JSON.stringify(response.data, null, 2));
                              
                  if (response.data.success === true) {
                    Swal.fire({
                      title: 'Login Successful!',
                      text: 'Welcome back! You’re now signed in to your agent account.' || response.data.message,
                      confirmButtonText: 'Continue',
                      confirmButtonColor: '#d33', // Red button
                      allowOutsideClick: false,   
                      allowEscapeKey: false,     
                      allowEnterKey: true         
                    }).then((result) => {
                      if (result.isConfirmed) {
                        //window.location.reload();
                        // Close registration modal if still open
                        const regModalEl = document.getElementById('agentRegistrationModal');
                        const regModal = bootstrap.Modal.getInstance(regModalEl);
                        if (regModal) regModal.hide();
                        // For Login Model
                        const loginModalEl = document.getElementById('agentSignInModal');
                        const loginModal = bootstrap.Modal.getInstance(loginModalEl);
                        if (loginModal) loginModal.hide();

                        const agentStore = useAgentStore();
                        agentStore.clearAgentDetails();
                        agentStore.setAgentDetails(response.data);
                        ///localStorage.setItem('agentDetails', JSON.stringify(response.data));

                        window.location.reload();

                      }
                    });

                  } else {
                    Swal.fire({
                      title: 'Error',
                      text: response.data.messages
                        ? Object.values(response.data.messages).flat()[0]  // takes first error message
                          : 'Sign In failed. Please try again.',
                      confirmButtonText: 'OK',
                      confirmButtonColor: '#d33', // red button
                    });
                  }
                } else {
                  Swal.fire({
                    title: 'Error',
                    text: response.data?.message || `Server responded with status ${response.status}`,
                  });
                }
              } catch (error) {
                console.error(error);
              } finally {
                this.isLoading = false;
              }
          },

          // close otp model
          closeOtpModal() {
            const otpModalEl = document.getElementById('otpAgentRegisterModal');
            const otpModal = bootstrap.Modal.getInstance(otpModalEl);
            if (otpModal) otpModal.hide();

            // Clear timer interval
            clearInterval(this.otpTimerInterval);

            // Remove any leftover backdrop
            //document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
          },

          // Close Registration and show Sign In properly
          closeRegAndOpenSignIn() {
              const regModalEl = document.getElementById('agentRegistrationModal');
              const regModal = bootstrap.Modal.getInstance(regModalEl);

              if (regModal) {
                  // Hide the registration modal
                  regModal.hide();

                  // Wait until fully hidden
                  regModalEl.addEventListener('hidden.bs.modal', () => {
                      const signInModalEl = document.getElementById('agentSignInModal');
                      const signInModal = new bootstrap.Modal(signInModalEl, {
                          backdrop: 'static', // optional
                          keyboard: false     // optional
                      });
                      signInModal.show();
                      window.location.reload();
                  }, { once: true });
              }
          },

          openRegistrationFromSignIn() {
              const signInModalEl = document.getElementById('agentSignInModal');
              const signInModal = bootstrap.Modal.getInstance(signInModalEl);

              if (signInModal) {
                  signInModal.hide();
                  signInModalEl.addEventListener('hidden.bs.modal', () => {
                      const regModalEl = document.getElementById('agentRegistrationModal');
                      const regModal = new bootstrap.Modal(regModalEl);
                      regModal.show();
                  }, { once: true });
              }
          },


          async validationMain(responseEmail) {
              //console.log('responseEmail : ', responseEmail);
              if (this.otpIncomplete) {
                this.errors.otpError = "Please enter the complete OTP.";
                return;
              }

              // Clear previous error
              this.errors.otpError = "";
              this.loading = true;

                const enteredOtp = this.otp.join('');
                try {
                  const res = await AgentVerifyOTP(responseEmail, enteredOtp);
                  ///console.log('OTP Verified-1!', res);
                  ///console.log('OTP Verified-2!', JSON.stringify(res.data, null, 2));
                  if (!res.data.success) {
                      this.errors.otpError = res.data.message || 'Invalid or expired OTP.';
                      return;
                  }

                  Swal.fire({
                      //title: 'OTP Verified!',
                      title: 'Registration Successful!',
                      //text: 'Your account verification is in process. You won’t be able to access your account until verified. You will receive an email once your account status is updated.',
                      text: res.data.message || 'Registration successful! You can now sign in and start using the Agent Portal.',
                      confirmButtonText: 'OK',
                      confirmButtonColor: '#d33',
                      allowOutsideClick: false,   
                      allowEscapeKey: false,     
                      allowEnterKey: true
                  }).then((result) => {
                      if (result.isConfirmed) {
                          // Optional: close OTP modal
                          const otpModalEl = document.getElementById('otpAgentRegisterModal');
                          const otpModal = bootstrap.Modal.getInstance(otpModalEl);
                          if (otpModal) otpModal.hide();

                          // Optional: reset OTP inputs
                          this.otp = Array(5).fill('');
                          this.errors.otpError = '';
                          // Refresh the page
                          window.location.reload();
                      }
                  });

                  // Close OTP modal and navigate
                  this.closeOtpModal();

                } catch (error) {
                    console.error("Axios Error:", error);
                    if (error.response?.data) {
                      this.errors.otpError = error.response.data.message || "Something went wrong.";
                    } else if (error.message) {
                      this.errors.otpError = `Request error: ${error.message}`;
                    } else {
                      this.errors.otpError = "An unknown error occurred.";
                    }
                } finally {
                    this.loading = false;
                }
          },

          resetOtpTimer() {
            if (this.otpTimerInterval) clearInterval(this.otpTimerInterval);
            this.timer = 180; // 3 minutes
            this.updateFormattedTime();
            this.startOtpTimer();
          },

          startOtpTimer() {
            this.updateFormattedTime();
            this.otpTimerInterval = setInterval(() => {
              if (this.timer > 0) {
                this.timer--;
                this.updateFormattedTime();
              } else {
                clearInterval(this.otpTimerInterval);
              }
            }, 1000);
          },

          updateFormattedTime() {
            ///console.log('updateFormattedTime : ');
            const minutes = String(Math.floor(this.timer / 60)).padStart(2, '0');
            const seconds = String(this.timer % 60).padStart(2, '0');
            this.formattedTime = `${minutes}:${seconds}`;
            this.$forceUpdate();
            ///console.log('this.formattedTime : ', this.formattedTime);
          },

          async handleResend(resendEmail) {
            //console.log('hai resend', resendEmail);
            if (this.timer > 0) {
              this.errors.otpError = 'Please wait before resending the OTP.';
              return;
            }

            this.resendloading = true;
            this.errors.otpError = '';
            const purpose = 'Agent';

            try {
              const sendOTP = await AgentOTPResend(resendEmail);

              if (sendOTP.data.success === true) {
                this.resendCount++;
                
                // reset timer properly
                this.resetOtpTimer();
                this.timerActive = true;

                // disable resend temporarily if needed
                if (this.resendCount >= 1) {
                  this.resendDisabled = true;
                  setTimeout(() => {
                    this.resendCount = 0;
                    this.resendDisabled = false;
                  }, 5 * 60 * 1000); // 5 minutes
                }

                this.errors.otpError = '';
              } else {
                this.errors.otpError = sendOTP.data.message || 'Error sending OTP.';
              }
            } catch (error) {
              this.errors.otpError = error?.message || 'Something went wrong.';
            } finally {
              this.resendloading = false;
            }
          },



          // the otp number enter section
          focusNext(index, event) {
            if (event.inputType === 'insertText' && index < this.otp.length - 1) {
              this.$refs.otpInputs[index + 1].focus();
            }
          },
          focusPrev(index, event) {
            if (!this.otp[index] && index > 0) {
              this.$refs.otpInputs[index - 1].focus();
            }
          },

          toggleDropdown() {
            this.showDropdown = !this.showDropdown;
          },

          handleClickOutside(event) {
            if (this.$refs.dropdownRef && !this.$refs.dropdownRef.contains(event.target)) {
              this.showDropdown = false;
            }
          },

          togglePassword() {
            this.showPassword = !this.showPassword;
          },

          checkAgentLogin() {
            const agentStore = useAgentStore();
            agentStore.loadAgentDetails(); 

            if (agentStore.agentDetails) {
              //console.log(' Agent is logged in:', JSON.stringify(agentStore.agentDetails, null, 2));
              this.isAgentLoggedIn = true;
              this.agentName = agentStore.agentDetails?.user?.name || 'Agent';
            } else {
              //console.log(' Agent is not logged in');
              this.isAgentLoggedIn = false;
              this.agentName = '';
            }
          },

          async logoutAgent() {
            //dropdownOpen.value = false;
            const agentStore = useAgentStore();

            try {
              const res = await AgentLogout();

              if (res.data && res.data.success) {
                this.$refs.toast?.showToast('Logout successful!', 'success', 1000); // 1 second
              } else {
                this.$refs.toast?.showToast(res.data.message || 'Logout failed!', 'error', 1000); // 1 second
              }
            } catch (error) {
              if (error.response) {
                this.$refs.toast?.showToast(error.response.data.message || `Error: ${error.response.status}`, 'error', 1000); // 1 second
              } else {
                this.$refs.toast?.showToast('Network or server error!', 'error', 1000); // 1 second
              }
            } finally {
              agentStore.clearAgentDetails();

              // Delay redirect slightly so toast is visible
              setTimeout(() => {
                window.location.reload();
              }, 1200); // slightly longer than toast duration
            }
          }


      }
    
}
</script>